import React, { useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { SPAViewContext } from '@confluence/spa-view-context';
import { AIUpsell } from '@confluence/change-edition/entry-points/AIUpsell';

import quickSummaryUpsellBannerLight from './assets/quickSummaryUpsellBannerLight.svg';
import quickSummaryUpsellBannerDark from './assets/quickSummaryUpsellBannerDark.svg';

const i18n = defineMessages({
	headerText: {
		id: 'quick-summary.upsell.header.text',
		defaultMessage: 'Save time, summarize',
		description: 'Header text for Quick Summary Upsell Dialog',
	},
	learnMoreLinkTextAdmin: {
		id: 'quick-summary.upsell.learn-more.link.text.admin',
		defaultMessage: 'More about Atlassian Intelligence',
		description: 'Short version of the learn more link text for AI Upsell Dialog',
	},
	learnMoreLinkTextUser: {
		id: 'quick-summary.upsell.learn-more.link.text.user',
		defaultMessage: 'Learn more about Atlassian Intelligence',
		description: 'Learn more link text for AI Upsell Dialog',
	},
	bodyTextAdmin: {
		id: 'quick-summary.upsell.body.text.admin',
		defaultMessage:
			'Save time and generate summaries for pages or blogs with Atlassian Intelligence. Upgrade to Premium to give it a try.',
		description: 'Body text for Quick Summary Upsell Dialog for admins',
	},
	bodyTextUser: {
		id: 'quick-summary.upsell.body.text.user',
		defaultMessage:
			'With the Premium plan, you could be saving time by summarizing pages and blogs using Atlassian Intelligence.',
		description: 'Body text for Quick Summary Upsell Dialog for non-admin users',
	},
});

export const ATLASSIAN_INTELLIGENCE_DOCS_LINK =
	'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/';

export const QuickSummaryUpsell = () => {
	const intl = useIntl();
	const { isSiteAdmin } = useContext(SPAViewContext);

	const headerText = intl.formatMessage(i18n.headerText);
	const bodyText = isSiteAdmin
		? intl.formatMessage(i18n.bodyTextAdmin)
		: intl.formatMessage(i18n.bodyTextUser);

	const learnMoreText = isSiteAdmin
		? intl.formatMessage(i18n.learnMoreLinkTextAdmin)
		: intl.formatMessage(i18n.learnMoreLinkTextUser);

	return (
		<AIUpsell
			title={headerText}
			body={bodyText}
			feature="quickSummary"
			learnMoreLink={{
				href: ATLASSIAN_INTELLIGENCE_DOCS_LINK,
				message: learnMoreText,
			}}
			image={{
				src: {
					default: quickSummaryUpsellBannerLight,
					dark: quickSummaryUpsellBannerDark,
				},
				alt: '',
			}}
		/>
	);
};
